import React, { useEffect, useState } from "react";
import "./Popup.css";

const reservationMethods = [
  { ID: 1, Code: "INV", ResevationMetiod: "Individual Call-In" },
  { ID: 2, Code: "WEB", ResevationMetiod: "Website / Online Booking" },
  { ID: 3, Code: "PSK", ResevationMetiod: "Passkey" },
  { ID: 4, Code: "CMB", ResevationMetiod: "Combo - Rooming List & Call-In" },
  { ID: 5, Code: "IMO", ResevationMetiod: "Individual Makes Own" },
  { ID: 6, Code: "RML", ResevationMetiod: "Rooming List" },
];

const ReservationMethodPopup = ({ show, onClose, onSelect }) => {
  const [searchText, setSearchText] = useState("");
  const [selectedId, setSelectedId] = useState(null);

  useEffect(() => {
    if (!show) return undefined;
    setSearchText("");
    setSelectedId(null);

    const handleEscape = (event) => {
      if (event.key === "Escape") onClose();
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [show, onClose]);

  if (!show) return null;

  const searchValue = searchText.replace(/\*/g, "").trim().toLowerCase();
  const filteredMethods = reservationMethods.filter((item) =>
    `${item.Code} ${item.ResevationMetiod}`.toLowerCase().includes(searchValue),
  );
  const selectedMethod = reservationMethods.find((item) => item.ID === selectedId);

  return (
    <div
      className="bon-lookup-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <div
        className="modal-dialog modal-dialog-centered bon-lookup-dialog"
        role="dialog"
        aria-modal="true"
        aria-labelledby="reservationMethodPopupTitle"
      >
        <div className="modal-content">
          <div className="modal-header bon-lookup-header">
            <h5 id="reservationMethodPopupTitle" className="modal-title">
              Search and Select Reservation Method
            </h5>
            <button
              type="button"
              className="btn-close bon-popup-close"
              aria-label="Close reservation method popup"
              onClick={onClose}
            />
          </div>

          <div className="modal-body">
            <div className="input-group bon-popup-search">
              <input
                type="search"
                className="form-control"
                placeholder="Search by code or description"
                value={searchText}
                onChange={(event) => setSearchText(event.target.value)}
                autoFocus
              />
              <button type="button" className="btn bon-search-button">Search</button>
            </div>

            <div className="table-responsive bon-popup-table-wrap">
              <table className="table table-sm table-hover mb-0 bon-popup-table">
                <thead>
                  <tr>
                    <th scope="col">Code</th>
                    <th scope="col">Description</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredMethods.length ? filteredMethods.map((item) => (
                    <tr
                      key={item.ID}
                      className={selectedId === item.ID ? "bon-row-selected" : ""}
                      onClick={() => setSelectedId(item.ID)}
                      onDoubleClick={() => onSelect(item)}
                    >
                      <td>{item.Code}</td>
                      <td>{item.ResevationMetiod}</td>
                    </tr>
                  )) : (
                    <tr><td colSpan="2" className="text-center py-4">No matching reservation method found.</td></tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="modal-footer bon-lookup-footer">
            <button type="button" className="btn bon-cancel-button" onClick={onClose}>Cancel</button>
            <button
              type="button"
              className="btn bon-select-button"
              disabled={!selectedMethod}
              onClick={() => onSelect(selectedMethod)}
            >
              Select
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReservationMethodPopup;
